import { getFormattedSiteName, getSelectedDivision } from '@/helpers/utils/siteUtils';

const SalesTax = () => {
  const divisonCode = getSelectedDivision() ?? 'ZB';
  let siteName = getFormattedSiteName(divisonCode);
  if (divisonCode === 'ZD') {
    siteName += '™';
  }
  return (
    <section className="flex flex-col gap-2 p-3">
      <div className="font-bold">Estimated Sales Tax</div>
      <div>
        {siteName} is required to collect sales tax on orders for residents of certain states. Sales tax shown here is
        an estimate. Actual sales tax is calculated when your order is placed and will be shown in your order
        confirmation email.
      </div>
    </section>
  );
};

export default SalesTax;
